import clsx from "clsx";

export function DetailGridLabel({ label }: { label: string }) {
    return (
        <span
            className={clsx(
                "heading-s flex min-h-12 w-1/3 min-w-[108px] cursor-pointer items-center break-words",
            )}
        >
            {label}
        </span>
    );
}
